import { Badge } from '@playbooks/ui/components/badge'

export default function Score({ value, hidden }: { value: number; hidden?: boolean }) {
  if (hidden) return null

  return value ? (
    <Badge data-testid="score-badge" variant="secondary" className="text-xs leading-4 font-semibold bg-border">
      {Number.isInteger(value) ? value : value?.toFixed(2)}
    </Badge>
  ) : null
}
